import { render, staticRenderFns } from "./PlaceAdd.vue?vue&type=template&id=03381b64&scoped=true"
import script from "./PlaceAdd.vue?vue&type=script&lang=js"
export * from "./PlaceAdd.vue?vue&type=script&lang=js"
import style0 from "./PlaceAdd.vue?vue&type=style&index=0&id=03381b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03381b64",
  null
  
)

export default component.exports